import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'

import Content from '../../components/Content'
import Container from '../../components/Container'

import List from './List'

export default class Technologies extends Component {
  render() {
    return (
      <Container>
        <Row>
          <Col md={9}>
            <Content className="animated fadeInLeft" />
          </Col>
        </Row>
        <List />
      </Container>
    )
  }
}
